import styled from "styled-components"

export const LoadingContainer = styled.div`
	display: flex;
	flex-direction: column;

	width: 100vw;
	height: 100vh;

	justify-content: center;
	align-items: center;
`

export const ErrorContainer = styled.div`
	width: 100vw;
	height: 100vh;

	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;

	background-color: #FFF;

	img {
		height: 70px;
		width: 70px;
	}
`

export const Text = styled.span`
	margin-top: 20px;
	color: #222;
`
